export const SAME_DAY = 'same-day'
export const SHIP_FROM_STORE = 'ship-from-store'
export const STANDARD = 'standard'
export const PICK_FROM_STORE = 'pick-from-store'
export const SAME_DAY_NEXT_BUSINESS_DAY_MESSAGE = 'Recibe el siguiente día hábil'
